import { Popover } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "DRPPopoverContainer";
export const classes = {
  root: `${PREFIX}-root`,
};

export const DRPPopoverContainer = styled(Popover)(({ theme }) => ({
  [`&.${classes.root} > .MuiPaper-root`]: {
    width: "580px",
    maxHeight: "520px",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
}));
